import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import { FooterContainer } from './CommunicationSettings.styles';

const CommunicationSettingsFooter = () => {
  const { t } = useTranslation();

  const {
    formState: { isDirty, isSubmitting },
  } = useFormContext();

  return (
    <FooterContainer>
      <PropertyEditActionWrapper tooltipId="save-communication-settings-button-tooltip">
        <Button
          bsStyle="primary"
          data-testid="save-communication-settings-button"
          type="submit"
          disabled={isSubmitting || !isDirty}
        >
          {t('common.save')}
        </Button>
      </PropertyEditActionWrapper>
    </FooterContainer>
  );
};

export default CommunicationSettingsFooter;
